import { render, staticRenderFns } from "./IcoInfo.vue?vue&type=template&id=6a8afe12"
import script from "./IcoInfo.vue?vue&type=script&lang=js"
export * from "./IcoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports